
import { defineComponent } from 'vue'
import ExportVulnerabilities from '~/apollo/mutations/dependency/ExportVulnerabilities.gql'
import ExportSbomForTarget from '~/apollo/mutations/dependency/ExportSbomForTarget.gql'
import { GraphqlMutationResponse } from '~/types/apolloTypes'

export default defineComponent({
  name: 'VulnerabilityListContextMenu',
  props: {
    targetId: {
      type: String,
      required: true
    },
    hasSbomExport: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async handleClickExport(format: 'CSV' | 'JSON') {
      try {
        const response: GraphqlMutationResponse = await this.$applyGraphqlMutation(
          ExportVulnerabilities,
          {
            objectId: this.targetId,
            format
          }
        )

        if (response.data?.exportVulnerabilityOccurrences?.ok) {
          this.$toast.success('Your export is being prepared. Please check your email.')
        } else {
          this.$logErrorAndToast(
            new Error('Failed to export vulnerabilities.'),
            'Failed to export vulnerabilities.'
          )
        }
      } catch (e) {
        this.$logErrorAndToast(e as Error, 'Failed to export vulnerabilities.')
      }
    },
    async handleClickExportSbom() {
      try {
        const response: GraphqlMutationResponse = await this.$applyGraphqlMutation(
          ExportSbomForTarget,
          {
            targetId: this.targetId
          }
        )

        if (response.data?.exportRepositoryTargetSbom?.ok) {
          this.$toast.success('Your export is being prepared. Please check your email.')
        } else {
          this.$logErrorAndToast(new Error('Failed to export SBOM.'), 'Failed to export SBOM.')
        }
      } catch (e) {
        this.$logErrorAndToast(e as Error, 'Failed to export SBOM.')
      }
    }
  }
})
